import { render } from "./Header.vue?vue&type=template&id=60f578be&scoped=true"
const script = {}

import "./Header.vue?vue&type=style&index=0&id=60f578be&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-60f578be"

export default script